<template>
  <div v-if="banners.length > 0">
    <carousel
      autoplay
      centerMode
      :perPageCustom="[[0, 1]]"
      :loop="true"
      :paginationEnabled=false
      :autoplayTimeout="4000"
    >
      <slide
        v-for="(banner, index) in banners"
        :key="index"
        :class="banner.type !== 1 ? 'clickable' : ''"
        @slideclick="bannerAction(banner)"
      >
        <v-img
          :src="responsiveImg(banner)"
          width="100%"
          height="auto"
        ></v-img>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
    }
  },
  components: {
    'carousel': Carousel,
    'slide': Slide
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe', 'rid'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    ...mapGetters('voucher', [
      'vouchers', 'allVouchers'
    ]),
    ...mapGetters('banner', [
      'banners'
    ]),
    ...mapGetters('menu', [
      'modeCats', 'selectedPanel'
    ]),
    ...mapGetters('promo', [
      'activePromo', 'promoMsg'
    ]),
  },
  methods: {
    async bannerAction (banner) {
      switch (banner.type){
        case 1:
          break
        case 2:
          await this.$store.dispatch('menu/resetSelectedPanel')
          const cat = this.modeCats.find(mc => mc.category_id === banner.category_id)
          await this.$store.dispatch('menu/setMainCat', cat.parent_id ? cat.parent_id : cat.category_id)
          await this.$store.dispatch('menu/setSelectedPanel', cat.category_id)
          break
        case 3:
          await this.$store.dispatch('promo/fetchActivePromo', banner.promo_code)
          if (this.promoMsg) {
            this.$store.dispatch('responseMessage', {
              type: 'error',
              title: 'Failed to activate promo',
              text: this.promoMsg,
              modal: true
            })
            this.$bus.$emit('showFullLoading', false)
            return
          }

          if (this.posType === 0) {
            await this.$store.dispatch('order/checkOrder')
          } else {
            await this.$store.dispatch('order/calculateOrder')
          }
          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: this.$t('successfully_applied_promo'),
            noBtn: this.$mq === 'sm' || this.$mq === 'md' || this.$mq === 'lg' || this.$mq === 'xl'
          })
          break
        case 4:
          window.open(banner.external_link)
          break
        default:
          break
      }
    },
    responsiveImg (banner) {
      const path = 'https://gemscms.aptsys.com.sg/gems_images/iorder_banner/' + this.rid + '/'
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return path + banner.mobile_banner
        case 'sm': return path + banner.mobile_banner
        case 'md': return path + banner.mobile_banner
        case 'lg': return path + banner.web_banner
        case 'xl': return path + banner.web_banner
      }
    }
  },
  async created () {
    //fetch banner
    await this.$store.dispatch('banner/fetchBanners')
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue